'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        zoomableMousewheel: {
            type: Boolean,
            kComposite: 'zoomable.mousewheel'
        },
        zoomableMousewheelLock: {
            type: String,
            kComposite: 'zoomable.mousewheel.lock'
        },
        zoomableSelection: {
            type: Boolean,
            kComposite: 'zoomable.selection'
        },
        zoomableSelectionKey: {
            type: String,
            kComposite: 'zoomable.selection.key'
        },
        zoomableSelectionLock: {
            type: String,
            kComposite: 'zoomable.selection.lock'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts-vue-wrapper/dist/es/KendoChartBase/Zoomable.js
// module id = 693
// module chunks = 0